import { render, staticRenderFns } from "./TerritoryArea.vue?vue&type=template&id=17ff881f"
import script from "./TerritoryArea.vue?vue&type=script&lang=js"
export * from "./TerritoryArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports